import { ChildAccountDisplayObject } from 'src/components/enterprise/Parents/Children/ParentChildAccountController/types';

export const makeOneAccountEditable = (
  childAccounts: ChildAccountDisplayObject[],
  keyOfNameBeingEdited: string
): ChildAccountDisplayObject[] => {
  return childAccounts.map((account) => {
    if (account.uniqueDisplayKey === keyOfNameBeingEdited) {
      return { ...account, isBeingEdited: true, isDisabled: false };
    }
    return { ...account, isBeingEdited: false, isDisabled: true };
  });
};
